import { XDropdownSelection } from '@adornis/popover/x-dropdown-selection.js';
import { customElement, property } from 'lit/decorators.js';

/**
 * @element tr-dropdown-selection
 */
@customElement('tr-dropdown-selection')
export class TrFormfieldWrapper<T, V> extends XDropdownSelection<T, V> {
  @property({ attribute: false }) guardFunction?: (item: T) => string | number | undefined;

  protected override _guardTrigger() {
    return [
      this._searchResultSelectables.value
        ?.map(s => (this.guardFunction ? this.guardFunction(s) : this.guardKey ? s[this.guardKey] : s))
        .join(),
      this._preSelectedItem,
      this._loading,
    ];
  }
}
